/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - Portfolio
 * Date: 5/17/21
 * Copyright All Rights Reserved
 */
import numeral from 'numeral';

const getDaysBestFormat = (days) => {
  if (days <= 14) {
    return `${numeral(days).format('0')} days`;
  }
  if (days < 7 * 8) {
    return `${numeral(days / 7).format('0')} weeks`;
  }
  return `${numeral(days / 30).format('0')} months`;
};

export default getDaysBestFormat;



// WEBPACK FOOTER //
// ./js/support/getDaysBestFormat.js